import superagent from 'superagent'
import moment from 'moment-timezone'

import getCookieByName from 'utils/getCookieByName'
import { generateHash } from 'utils/random'
import { get } from 'lodash'
import urlLib from 'url'
import Cookies from 'js-cookie'
import config from '../config'
import { maskIds } from 'utils/url'
import activityMonitorStorage from 'helpers/activityMonitorStorage'

const baseUrl = config.baseUrl || ''
const methods = ['get', 'post', 'put', 'patch', 'del']

function formatUrl(path, isExternal, { userType, removeUserType, locale }) {

  if (path && path.indexOf('api/') === 0) {
    let apiPath = config.apiURL + '/' + path.slice(4)
    let prefix = '?'

    if (userType && !removeUserType) {
      if (apiPath.includes('?')) {
        prefix = '&'
      }
      apiPath = `${apiPath}${prefix}userType=${userType}`
    }

    if (locale) {
      if (apiPath.includes('?')) {
        prefix = '&'
      }
      apiPath = `${apiPath}${prefix}locale=${locale}`
    }

    !__SERVER__ && console.debug('Calling server...', apiPath.split('?')[0])
    return apiPath
  }

  if (path && path.indexOf('apiv2/') === 0) {
    let apiPath = config.apiv2URL + '/' + path.slice(6)
    let prefix = '?'

    if (userType && !removeUserType) {
      if (apiPath.includes('?')) {
        prefix = '&'
      }
      apiPath = `${apiPath}${prefix}userType=${userType}`
    }

    if (locale) {
      if (apiPath.includes('?')) {
        prefix = '&'
      }
      apiPath = `${apiPath}${prefix}locale=${locale}`
    }

    !__SERVER__ && console.debug('Calling server...', apiPath.split('?')[0])
    return apiPath
  }

  if (isExternal) {
    return path
  }

  let adjustedPath = path[0] !== '/' ? '/' + path : path

  switch (adjustedPath) {
    case '/save-user':
      adjustedPath = '/save-user'
      break
    case '/logout':
      adjustedPath = '/logout'
      break
    case '/user-autologin':
      adjustedPath = '/user-autologin'
      break
    case '/tokens':
      adjustedPath = '/tokens'
      break
    case '/loadAuth':
      adjustedPath = '/loadAuth'
      break
    case '/authenticate':
      adjustedPath = '/authenticate'
      break
    case '/download-image':
      adjustedPath = '/download-image'
      break
    default:
      adjustedPath = config.apiURL + adjustedPath
      break
  }

  if (__SERVER__) {
    // Prepend host and port of the API server to the path.
    // console.log(
    //   'Calling from server',
    //   'http://' + config.host + ':' + config.port + adjustedPath
    // )
    return 'http://' + config.host + ':' + config.port + adjustedPath
  }

  // if (!__SERVER__) {
  //   console.log('Calling from client...', baseUrl + adjustedPath)
  // }
  return baseUrl + adjustedPath
}

class _ApiClient {
  constructor(req) {
    methods.forEach(
      method =>
        this[method] = (
          path,
          {
            params,
            data,
            external,
            removeToken = false,
            formData = false,
            textResponse,
            removeUserType = false,
            unauthorizedAction = true,
            isPublic = false
          } = {}
        ) =>
          new Promise((resolve, reject) => {
            const request = superagent[method](
              formatUrl(path, external || textResponse, {
                userType: this.userType,
                removeUserType,
                locale: this.locale
              })
            )
            const endpoint = get(request, 'url')
              ? method.toUpperCase() + ' ' + maskIds(urlLib.parse(get(request, 'url')).pathname)
              : undefined
            const requireJson = __CLIENT__ && !external && !textResponse

            activityMonitorStorage.resetLastActivity()

            this.unauthorizedAction = unauthorizedAction
            this.isPublic = isPublic

            if (params) {
              request.query(params)
            }

            if (__SERVER__ && req.get('cookie')) {
              this.cookieLocaleCode = getCookieByName(
                req.get('cookie'),
                'cookieLocaleCode'
              )

              request.set('cookie', req.get('cookie'))
            }

            request.withCredentials()

            if (requireJson) {
              request.set('Accept', 'application/json')
            }

            if (this.token && !removeToken) {
              request.set('Authorization', 'Bearer ' + this.token)
            }

            if (this.organizationId) {
              request.query(`organizationId=${this.organizationId}`)
            }

            if (moment.tz.guess()) {
              request.query(`timeZone=${moment.tz.guess()}`)
            }

            if (config.productionServer) {
              request.set('X-Frame-Options', 'DENY')
            }

            const requestId = generateHash(20)
            request.set('X-Request-ID', requestId)

            const isCSFRCheckNeeded = request.method !== "GET"
            const csfrToken = Cookies.get('csrfts')
            const csfrTokenORBg02 = Cookies.get('XSRF-TOKEN')

            if(isCSFRCheckNeeded){
              if(csfrToken && request.url.includes("v1")){
                request.set('Csrf-Token', csfrToken)
              }

              if(csfrTokenORBg02 && request.url.includes("v2")){
                request.set('Csrf-Token', csfrTokenORBg02)
              }
            }

            // Client identification = backoffice
            request.query('c=b')

            if (formData) {
              const parts = [].concat(data)
              const multipartData = new FormData()

              parts.forEach(item => {
                multipartData.append('file', item.file, item.filename)
              })

              request.send(multipartData)
            }

            if (data && !formData) {
              request.send(data)
            }

            const timeStamp = moment().unix()

            request.end((err, res = {}) => {
              let responseObject = {}

              if (method === 'get') {
                if (!textResponse) {
                  responseObject = res.body
                } else {
                  responseObject = res.text
                }
              } else {
                try {
                  responseObject = res.text ? JSON.parse(res.text) : {}
                } catch (e) {
                  responseObject = {}
                }
              }

              err
                ? reject(
                {
                  body: responseObject || {},
                  headers: res.headers,
                  timeStamp,
                  err,
                  unauthorizedAction,
                  requestId,
                  requireJson,
                  endpoint
                } || err
                )
                : resolve({
                  body: responseObject || {},
                  headers: res.headers,
                  timeStamp,
                  requestId,
                  requireJson,
                  endpoint
                })
            })
          })
    )
  }
}

const ApiClient = _ApiClient

export default ApiClient
